const buildState = () => {
    return {
        onBoardingFormStatus : null,
    };
};

const state = buildState();

const getters = {
    showOnBoardingForm : (state) => state.onBoardingFormStatus === 'CREATED',
};

const mutations = {
    reset(state) {
        Object.assign(state, buildState());
    },
};

const actions = {
    init() {
        this.$apiRouter.addRoutes({
            login     : { uri : '/login' },
            checkTfa  : { uri : '/tfa' },
            tfa       : { uri : '/user/:userId/tfa' },
            tfaSecret : { uri : '/user/:userId/tfa/secret' },

            tfaBackup         : { uri : '/user/:userId/tfa/backup' },
            tfaGenerateBackup : { uri : '/user/:userId/tfa/backup/generate' },
            resetPassword     : { uri : '/user/password/reset' },
            newPassword       : { uri : '/user/password/new' },
            isTfa             : { uri : '/istfa/:token' },
            checkTfaAnon      : { uri : '/tfaanon' },
        });
    },

    resetState({ commit }) {
        commit('reset');
    },

    login({ commit }, user) {
        return new Promise((resolve, reject) => {
            commit('resetLogin');
            this.$apiClient
                .request({
                    url          : this.$apiRouter.buildUri('login'),
                    data         : user,
                    method       : 'POST',
                    errorHandler : true,
                })
                .then(() => {
                    state.onBoardingFormStatus = this.$jwtStorage.get(
                        'onBoardingFormStatus'
                    );
                    commit('updateLogin');
                    resolve();
                })
                .catch((response) => reject(response));
        });
    },

    sendTfa({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            this.$apiClient
                .post(
                    'checkTfa',
                    {},
                    {},
                    {
                        _auth_code : data.code,
                    }
                )
                .then((response) => {
                    commit('updateLogin');
                    resolve(response);
                })
                .catch((error) => {
                    if (error.status === 403) {
                        dispatch('logout');
                    }

                    reject(error);
                });
        });
    },

    getLoggedUserDetails({ commit, dispatch, getters }) {
        const loggedId = getters.getLoggedUser.id;
        dispatch('loadUser', loggedId, { root : true }).then((result) => {
            commit('addLoginDetails', result);
        });
    },

    requestNewPassword(context, data) {
        return this.$apiClient.post('resetPassword', {}, { email : data });
    },

    // HINT: this is kind of unique in that nothing is changed in the store. The
    // password is simply submitted, never remembered. No commits or dispatches
    // needed.
    updatePassword(context, loginData) {
        return new Promise((resolve, reject) => {
            this.$apiClient
                .post('newPassword', {}, loginData)
                .then(() => resolve())
                .catch((error) => reject(error));
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
